<template>
  <div class="person-list-item" :class="{ 'user': isUser, disabled }">
    <div class="gender-bar" :class="genderClassRef"></div>
    <img src="@/assets/icons/person_gray_150.png"/>
    <span v-if="person">
      {{ person.displayName }} 
      <small v-if="person.birthYear">({{ person.birthYear }})</small>
    </span>
  </div>
</template>

<style lang="scss" scoped>
.person-list-item {
  display: flex;
  gap: 0.25rem;
  align-items: center;

  .gender-bar {
    width: 8px;
    align-self: stretch;
    background-color: #e9e9e9;

    &.male {
      background-color: #c3d5ea;
    }

    &.female {
      background-color: #fadce1;
    }
  }

  img {
    width: 20px;
    opacity: 20%;
  }

  &.user img {
    opacity: 60%;
  }

  &.disabled {
    opacity: 50%;
  }
}
</style>

<script lang="ts" setup>
import { computed } from "vue"
import { ViewPerson } from "@/rd/ResearchDataModel"

// NOTE: This component is used in search results that do NOT have access to stores

const props = defineProps<{
  person?: ViewPerson
  isUser?: boolean
  disabled?: boolean
}>()

const genderClassRef = computed(() => [props.person?.displayProperties.gender?.toLowerCase()])

</script>
